import { render, staticRenderFns } from "./Boeken.vue?vue&type=template&id=b069d668"
import script from "./Boeken.vue?vue&type=script&lang=js"
export * from "./Boeken.vue?vue&type=script&lang=js"
import style0 from "./Boeken.vue?vue&type=style&index=0&id=b069d668&prod&lang=css"
import style1 from "./Boeken.vue?vue&type=style&index=1&id=b069d668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports